export default __webpack_public_path__ + "static/media/mute.971c615b.svg";